import {useEffect, useState} from 'react';
import {Skeleton} from '@mui/material';
import {EntityActivitiesRepository} from '../../../repositories/entity-activities';
import {useParams} from 'react-router-dom';
import {CarePlanConfiguration} from '../../../backend/interfaces/care-plan-configuration';

interface MedicineCardValueProps {
  activitiesSectorId: string;
  activitiesGroupId: string;
  activityTypeId: string;
  configuration: CarePlanConfiguration;
  itemId: string;
}

const MedicineCardValue = ({
  activitiesSectorId,
  activitiesGroupId,
  activityTypeId,
  configuration,
  itemId,
}: MedicineCardValueProps) => {
  const {entityId} = useParams<{entityId: string}>();
  const [medicineItem, setMedicineItem] = useState<string | undefined>(undefined);

  useEffect(() => {
    const fetchCarePlanConfigurationItemById = async () => {
      const item = await EntityActivitiesRepository.instance.getGroupCarePlanConfigurationDataValue(
        entityId,
        activitiesSectorId,
        activitiesGroupId,
        activityTypeId,
        configuration.id!,
        itemId
      );
      setMedicineItem(item.name);
    };

    fetchCarePlanConfigurationItemById();
  }, [activitiesGroupId, activitiesSectorId, activityTypeId, configuration, entityId, itemId]);

  if (!medicineItem) {
    return (
      <Skeleton
        animation="wave"
        variant="rectangular"
        sx={{
          height: '20px',
          width: '50%',
          borderRadius: '10px',
        }}
      />
    );
  }

  return (
    <>
      <label className="title">{configuration?.name}</label>
      <div className="value">{medicineItem}</div>
    </>
  );
};

export default MedicineCardValue;
